import { Model } from '@vuex-orm/core';

export default class FlashcardSessionState extends Model {
    static entity = 'flashcard_session_state';

    static primaryKey = 'uuid';

    static fields() {
        return {
            uuid: this.attr(null),
            queue: this.attr(() => []),
            currentIndex: this.attr(0),
            responses: this.attr(() => ({})),
            viewedIndices: this.attr(() => []),
            sessionNumber: this.attr(1),
            fsrsEnabled: this.attr(false),
        };
    }
}
